module.exports = __webpack_public_path__ + "img/registration_confirmation_lp.bb4ba9c9.jpg";